export default __webpack_public_path__ + "static/media/platelet.6e332004.svg";